/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionIssuerMcpServer,
  UserSessionIssuerMcpServer$inboundSchema,
} from "./usersessionissuermcpserver.js";

/**
 * Result type for listing the MCP servers attached to a user_session_issuer.
 */
export type ListUserSessionIssuerMcpServersResult = {
  items: Array<UserSessionIssuerMcpServer>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListUserSessionIssuerMcpServersResult$inboundSchema: z.ZodMiniType<
  ListUserSessionIssuerMcpServersResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(UserSessionIssuerMcpServer$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listUserSessionIssuerMcpServersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionIssuerMcpServersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListUserSessionIssuerMcpServersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionIssuerMcpServersResult' from JSON`,
  );
}
